import React, { useState, useEffect } from "react";
 import { toast } from "react-toastify";
import {
  TextField,
  Button,
  Divider,
  Typography,
  Box,
  Link,
  Alert,
  Grid,
  AppBar,
  Toolbar,
  Container,
  Card,
  CardContent,
  InputAdornment,
  IconButton,
  Tooltip,
} from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import authService from "../../services/authService";
import { useNavigate } from "react-router-dom"; // ✅ yeh important hai
import { jwtDecode } from "jwt-decode"; // Using named import instead of default
import HexaLoader from "../loader/Loader";
import { setToken, startTokenTimer } from "../../services/authService";
import { apiPost } from "../../services/api";
const Login = ({ isPopup = false }) => {
  const [isRegister, setIsRegister] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const err = params.get("error");

  if (err === "unauthorized_email") {
    toast.error("Access restricted.Contact with an Administrator");
  } else if (err) {
    toast.error("Microsoft login failed. Please try again.");
  }

  // optional: ?error ko URL se hata do taa ki refresh par dobara toast na aaye
  if (err) {
    const url = new URL(window.location.href);
    url.searchParams.delete("error");
    window.history.replaceState({}, "", url);
  }
}, []);


  const toggleMode = () => {
    setIsRegister((prev) => !prev);
    setError("");
    setSuccess("");
    setEmail("");
    setPassword("");
    setConfirmPass("");
  };

const handleSubmit = async () => {
    setError("");
    setSuccess("");
 
    if (isRegister && password !== confirmPass) {
      setError("Passwords don't match");
      return;
    }
 
    setLoading(true);
    try {
      if (isRegister) {
        const data = await authService.register({ email, password });
        setSuccess(data?.message || "Registration successful. Please log in.");
        setPassword("");
        setConfirmPass("");
        setIsRegister(false);
      } else {
const response = await apiPost("/auth/login", { email, password });
if (response.data.success && response.data.token) {
  setToken(response.data.token); // 👈 yeh token setter call karega
  startTokenTimer(60);   // 1 min ka timer lagao
  localStorage.setItem("user", JSON.stringify(response.data.user));
  window.location.href = "/dashboard"; // 👈 navigate ki jagah direct redirect (refresh ke liye)
} else {
  setError(response.data.message || "Login failed!");
}
 
 
      }
    } catch (err) {
      setError(err?.response?.data?.message || err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };
 

  const handleGoogleSuccess = async (credentialResponse) => {
    if (!credentialResponse.credential) {
      setError("No credential returned from Google");
      return;
    }

    try {
      setLoading(true);

      const decoded = jwtDecode(credentialResponse.credential);
      const { email, name, sub: googleId } = decoded;

      const res = await fetch(`https://buzzly-dev-api.qsstechnosoft.com/api/auth/google-login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, name, googleId }),
      });

      const data = await res.json();

      if (res.ok) {
        localStorage.setItem("user", JSON.stringify(data.user));
        localStorage.setItem("token", data.token);
        setTimeout(() => {
          navigate("/dashboard");
          setLoading(false);
        }, 1000);
      } else {
        setError(data.message || "Login failed");
        setLoading(false);
      }
    } catch (err) {
      setError("Google login failed");
      setLoading(false);
    }
  };

  const API_BASE =
  (import.meta?.env && import.meta.env.VITE_API_BASE) ||          // Vite
  process.env.MICROSOFT_AUTH_URL ||                               // CRA/Next
  (window.location.hostname === "localhost"
    ? "http://localhost:5000/api"                                 // dev default
    : "https://buzzly-api.qsstechnosoft.com/api");           // prod default
 
const API_ORIGIN = API_BASE.replace(/\/api\/?$/, "");
 const handleMicrosoftLogin = () => {
  window.location.href = `${API_ORIGIN}/api/auth/microsoft`;
};
 
  


  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: isPopup ? "auto" : "100vh",
        background: "transparent",
      }}
    >
      {!isPopup && (
        <>
          <AppBar position="fixed" elevation={2} sx={{ backgroundColor: "white", color: "text.primary" }}>
            <Toolbar sx={{ justifyContent: "space-between", height: 48 }}>
              <Typography variant="h6" sx={{ fontWeight: 600, fontSize: { xs: "1.1rem", sm: "1.2rem" } }}>
                Buzzly
              </Typography>
            </Toolbar>
          </AppBar>
          <Toolbar />
        </>
      )}

      <Container
        component="main"
        maxWidth={isPopup ? "sm" : "xs"}
        sx={{
          mt: isPopup ? 0 : 8,
          mb: isPopup ? 0 : 4,
          width: isPopup ? "100%" : undefined,
          padding: "45px",
        }}
      >
        <Card
          elevation={isPopup ? 0 : 3}
          sx={{
            borderRadius: 2,
            maxWidth: isPopup ? "95%" : 360,
            mx: "auto",
            backgroundColor: "transparent",
          }}
        >
          <CardContent sx={{ p: 4 }}>
            <Typography variant="h5" align="center" gutterBottom sx={{ mb: 3 }}>
              {isRegister ? "Create Your Account" : "Choose Sign In Method"}
            </Typography>

            {!isRegister && (
              <>
                <Grid sx={{ display: "flex", gap: 3, flexDirection: "column", width: "100%" }}>
                 
                      
<button 
  onClick={handleMicrosoftLogin} 
  style={{ 
    background: "#4896a1", 
    color: "white", 
    border: "1px solid #ddd", 
    borderRadius: 12, 
    width: "100%", 
    padding: "12px 16px", 
    marginTop: 12 ,cursor:"pointer"
  }}
>
  Sign in with Microsoft Outlook
</button>



                </Grid>
                <Divider sx={{ my: 2 }}>OR CONTINUE WITH</Divider>
              </>
            )}

           <Box display="flex" flexDirection="column" gap={2} width="100%">
  <TextField 
    label="Email Address" 
    type="email" 
    value={email} 
    disabled   // ✅ disable
    onChange={(e) => setEmail(e.target.value)} 
    fullWidth 
  />
  
  <TextField
    label="Password"
    type={showPassword ? "text" : "password"}
    value={password}
    disabled   // ✅ disable
    onChange={(e) => setPassword(e.target.value)}
    fullWidth
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <IconButton disabled /* ✅ disable toggle */>
            {showPassword ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </InputAdornment>
      ),
    }}
  />

  {isRegister && (
    <TextField
      label="Confirm Password"
      type={showConfirmPassword ? "text" : "password"}
      value={confirmPass}
      disabled   // ✅ disable
      onChange={(e) => setConfirmPass(e.target.value)}
      fullWidth
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton disabled /* ✅ disable toggle */>
              {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  )}
 <Tooltip title="Only users authorized by the administrator can log in or register">
<span>

  <Button 
    variant="contained" 
    fullWidth 
    size="large"
    disabled   // ✅ disable button
  >
    {isRegister ? "Register" : "Sign in with Password"}
  </Button>
</span>
 </Tooltip>
</Box>




            {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
            {success && <Alert severity="success" sx={{ mt: 2 }}>{success}</Alert>}

            <Box textAlign="center" mt={3}>
              <Typography variant="body2">
                {isRegister ? "Already have an account?" : "Don't have an account?"}{" "}
                <Link component="button" onClick={toggleMode}>
                  {isRegister ? "Login" : "Register"}
                </Link>
              </Typography>
            </Box>

            {!isRegister && (
              <Typography variant="caption" display="block" textAlign="center" mt={3} color="text.secondary">
                For support, contact your system administrator
              </Typography>
            )}
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default Login;
